import { BreadcrumbLink, Breadcrumbs } from "@synota-io/synota-shared-ui";
import { NODES_BLUE_PENGUIN_PATH, NODES_BLUE_PENGUIN_UNASSIGNED_PATH } from "../../../paths";
import { useMatch } from "react-router-dom";

export const BpNodesBreadcrumbs = () => {
  const matchUnassigned = useMatch(NODES_BLUE_PENGUIN_UNASSIGNED_PATH);

  const links: BreadcrumbLink[] = [{ label: "Blue Penguin", path: NODES_BLUE_PENGUIN_PATH }];

  if (matchUnassigned) {
    links.push({ label: "Unassigned", path: NODES_BLUE_PENGUIN_UNASSIGNED_PATH });
  }

  return <Breadcrumbs links={links} />;
};
